// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/commonapis/gen/buhta_common_v1_country.ml",
      54,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "Country"
                    ]]
                },
                "V1"
              ]]
          },
          "Common"
        ]]
    });

const Common = Caml_module.init_mod([
      "proto/commonapis/gen/buhta_common_v1_country.ml",
      79,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "Country"
              ]]
          },
          "V1"
        ]]
    });

const V1 = Caml_module.init_mod([
      "proto/commonapis/gen/buhta_common_v1_country.ml",
      102,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "Country"
        ]]
    });

const Country = Caml_module.init_mod([
      "proto/commonapis/gen/buhta_common_v1_country.ml",
      123,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.common.v1.Country";
}

function to_int(param) {
  switch (param) {
    case /* COUNTRY_UNSPECIFIED */0 :
        return 0;
    case /* COUNTRY_KAZ */1 :
        return 10;
    case /* COUNTRY_KGZ */2 :
        return 20;
    case /* COUNTRY_UZB */3 :
        return 30;
    
  }
}

function from_int_exn(n) {
  if (n >= 11) {
    if (n !== 20) {
      if (n !== 30) {
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
      } else {
        return /* COUNTRY_UZB */3;
      }
    } else {
      return /* COUNTRY_KGZ */2;
    }
  } else if (n !== 0) {
    if (n >= 10) {
      return /* COUNTRY_KAZ */1;
    } else {
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_value",
                  VAL: n
                });
    }
  } else {
    return /* COUNTRY_UNSPECIFIED */0;
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn(e);
            });
}

function to_string(param) {
  switch (param) {
    case /* COUNTRY_UNSPECIFIED */0 :
        return "COUNTRY_UNSPECIFIED";
    case /* COUNTRY_KAZ */1 :
        return "COUNTRY_KAZ";
    case /* COUNTRY_KGZ */2 :
        return "COUNTRY_KGZ";
    case /* COUNTRY_UZB */3 :
        return "COUNTRY_UZB";
    
  }
}

function from_string_exn(s) {
  switch (s) {
    case "COUNTRY_KAZ" :
        return /* COUNTRY_KAZ */1;
    case "COUNTRY_KGZ" :
        return /* COUNTRY_KGZ */2;
    case "COUNTRY_UNSPECIFIED" :
        return /* COUNTRY_UNSPECIFIED */0;
    case "COUNTRY_UZB" :
        return /* COUNTRY_UZB */3;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, Country, {
      name: name,
      to_int: to_int,
      from_int: from_int,
      from_int_exn: from_int_exn,
      to_string: to_string,
      from_string_exn: from_string_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "Country"
        ]]
    }, V1, {
      Country: Country
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "Country"
              ]]
          },
          "V1"
        ]]
    }, Common, {
      V1: V1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "Country"
                    ]]
                },
                "V1"
              ]]
          },
          "Common"
        ]]
    }, Buhta, {
      Common: Common
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
